import React from "react"
import {Toast} from "react-weui"
import GogleMap from './GoogleMap'
import {cities} from "../../../../../data"
import config from '../../../../../config.app'

function estimateHeight() {
  return window.innerHeight - (191 + 55 + 56)
}

class ShowOrigin extends React.PureComponent {
  constructor(props) {
    super(props);
    this.mapcontainer = React.createRef();
  }

  render() {
    return (
      <div className="show-origin">
        <div
          className="map-container"
          ref={this.mapcontainer}
        >
          <GogleMap
            originCoords={this.props.originCoords}
            destinationCoords={this.props.destinationCoords}
            city={this.props.city}
            cities={cities}
            googleMapURL={config.google_maps_api}
            loadingElement={<div style={{ height: `100%` }} />}
            //containerElement={<div style={{ height: `${this.mapcontainer.current ? this.mapcontainer.current.clientHeight : estimateHeight()}px` }} />}
            containerElement={<div style={{ flexGrow: 2 }} />}
            mapElement={<div style={{ height: `100%` }} />}
          />
          {this.props.fetchingCoords ? <Toast icon="loading" show>Loading...</Toast> : ""}
        </div>
        <div className="bottom">
          <h1 className="mtop">我们在哪儿接您?</h1>
          
          <div className="form">
            
            <div className="left">
              <div className="cc">
                <div className="c">&nbsp;</div>
              </div>
              <div className="lwrapper">
                <div className="l">&nbsp;</div>
                <div className="l">&nbsp;</div>
              </div>
              <div className="cc">
                <div className="c">&nbsp;</div>
              </div>
            </div>
          
            <div className="right">
          
              <div className="orig">出发地</div>

              <div
                className="faux-input"
                onClick={() => {
                  this.props.push(`/catalogo/${this.props.city}/transportation?step=searchOrigin`)
                }}
              >
                {this.props.originAddress}
              </div>

              <div className="dest">目的地</div>
              
              <div 
                className="faux-input"
                onClick={() => {
                  this.props.push(`/catalogo/${this.props.city}/transportation`)
                }}
              >
                <div className="destination-address">
                  {this.props.destinationAddress}
                </div>
                <div className="otro">
                  {"其他地方 >"}
                </div>
              </div>
              
            </div>
            
          </div>
        </div>
      </div>
    )
  }
}

export default ShowOrigin


// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/components/ShowOrigin.jsx